const colors = {
  blue: '#0066FF',
  red: '#EB1500',
  green: '#21E053',
  pureBlack: '#000',
  pureWhite: '#FFF',
  midGrey: '#808080',
  greyDark: '#767676',
  greyMedium: '#AAAAAC',
  grey: '#D7D7D7',
  greyLight: '#D8D8D8',
  greyLighter: '#F1F1F1',
}

export default colors
